import styled from "styled-components";

export const StyledSoundDiv = styled.div`
  display: inline-block;
  margin: 0;
  padding: 0;
`;

export const StyledSoundButton = styled.button`
  margin: 0;
  padding: 10px;
  min-height: 30px;
  width: 100%;
  border-radius: 20px;
  border: none;
  color: white;
  background: #333;
  font-family: 'Pixel', Arial, Helvetica, sans-serif;
  outline: none;
  cursor: pointer;
`;